import { gql } from '@apollo/client';

export const ALL_SP_INTERVENTION_COHORTS = gql`
  query AllSPInterventionCohorts($input: CohortFilterArgs!) {
    cohorts: getSPInterventionCohorts(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          updatedAt

          description
          name

          # computed
          beneficiariesCount
          institutionsCount
          peopleCount

          intervention {
            id
            name
          }
          ownerOrganisation {
            id
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
        }
      }
    }
  }
`;
